import React, { useEffect, useState } from 'react';
import Modal from '../../BaseComponents/Modal';
import Loader from '../../BaseComponents/Loader';
import './ReferralLetterViewModal.scss';

interface ReferralLetterViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  pdfUrl: string | null;
  filename: string;
  isGenerating?: boolean;
}

const ReferralLetterViewModal: React.FC<ReferralLetterViewModalProps> = ({
  isOpen,
  onClose,
  pdfUrl,
  filename,
  isGenerating = false,
}) => {
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setIsIframeLoading(true);
    }
  }, [isOpen, pdfUrl]);

  const showLoader = isGenerating || (pdfUrl && isIframeLoading);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isFullscreen
      closeOnEsc
    >
      <div className='referral-letter-view-modal'>
        {showLoader && (
          <div className='referral-letter-view-modal__loader'>
            <Loader />
          </div>
        )}
        {pdfUrl && (
          <iframe
            className='referral-letter-view-modal__iframe'
            src={pdfUrl}
            title={filename}
            name={filename}
            onLoad={() => setIsIframeLoading(false)}
            style={{ display: showLoader ? 'none' : 'block' }}
          />
        )}
      </div>
    </Modal>
  );
};

export default ReferralLetterViewModal;
